const Dropdown = require('bootstrap/js/dist/dropdown');
const Tooltip = require('bootstrap/js/dist/tooltip');
const Modal = require('bootstrap/js/dist/modal');
const Collapse = require('bootstrap/js/dist/collapse');

window.bootstrap = { Dropdown, Tooltip, Modal, Collapse };
